import { toast } from 'sonner';
import availabilityApi from '@/features/dashboard/availability/api/availabilityApi.ts';
import {
  AvailabilityInfoDto,
  CatalogRefDto,
  CatalogRefKind,
} from '@/features/dashboard/availability/types/AvailabilityDto.ts';
import { TourOptionDto } from '@/features/dashboard/tourOptions/types/TourOptionDto.ts';

const isLimitExceeded = (info: AvailabilityInfoDto) =>
  info.limit != null && info.currentCount > info.limit;

const toCatalogRefs = (option: TourOptionDto): CatalogRefDto[] => [
  { kind: CatalogRefKind.OPTION, id: option.id },
  ...option.variants.flatMap((variant) =>
    variant.id ? [{ kind: CatalogRefKind.VARIANT, id: variant.id }] : [],
  ),
];

/**
 * Limit ustawiony poniżej liczby już zapisanych uczestników to ostrzeżenie,
 * nie blokada — backend zapisuje taką konfigurację, a komunikat składa front.
 */
export const notifyTourOptionLimitWarnings = async (
  tourId: string,
  option: TourOptionDto,
) => {
  const refs = toCatalogRefs(option);
  try {
    const availability = await availabilityApi.getAvailability({
      tourId,
      refs,
    });
    const infoByEntityId = new Map(
      availability.map(({ availability: info }) => [info.entityId, info]),
    );
    // Kolejność odpowiedzi nie jest ustalona, więc komunikat składamy w kolejności zapytania.
    const exceeded = refs.flatMap((ref) => {
      const info = infoByEntityId.get(ref.id);
      return info && isLimitExceeded(info)
        ? [`${info.name} (${info.currentCount}/${info.limit})`]
        : [];
    });
    if (exceeded.length > 0) {
      toast.warning('Limit miejsc jest niższy niż liczba zapisanych', {
        description: exceeded.join(', '),
      });
    }
  } catch {
    // Ostrzeżenie jest best-effort — błąd pobrania obłożenia nie psuje zapisu.
  }
};
